// extracted by mini-css-extract-plugin
export default {"accentColor":"about-us_accentColor__JC+jB","stackWidth":"about-us_stackWidth__yd0zx","videoWrapper":"about-us_videoWrapper__VAjAP"};